module.exports = __webpack_public_path__ + "static/media/lyn-win.2c46ae64.png";